import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  locations: [],

  loading: false,
  error: "",
  success: "",
  isEditing: false,
  searchedLocation: [],
};

const LocationSlice = createSlice({
  name: "Location",
  initialState,
  reducers: {
    saveLocation(state, action) {
      state.locations = action.payload;
    },
    saveSearchedLocation(state, action) {
      state.searchedLocation = action.payload;
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },

    setIsEditing(state, action) {
      state.isEditing = action.payload;
    },

    locationError(state, action) {
      state.error = action.payload;
      state.loading = false;
    },

    locationSuccess(state, action) {
      state.success = action.payload;
      state.loading = false;
    },

    clearMessages(state) {
      state.error = "";
      state.success = "";
    },
  },
});

export const { clearMessages, saveSearchedLocation, setLoading, setIsEditing, saveLocation } =
  LocationSlice.actions;

export default LocationSlice.reducer;
